/**
 * Merges new email recipients into an existing comma-separated recipient string.
 * The merge is case-insensitive and only appends emails that are not already present.
 * This keeps recipient deduplication logic consistent across forms and hooks.
 */
export function appendUniqueEmailRecipients(
  currentRecipients: string | undefined,
  newRecipients: string[] | null | undefined
): string {
  const current = currentRecipients || "";
  if (!newRecipients?.length) return current;

  const existing = current
    ? current.split(",").map((email) => email.trim().toLowerCase()).filter(Boolean)
    : [];
  const existingSet = new Set(existing);

  const recipientsToAdd = newRecipients
    .map((email) => email.trim())
    .filter((email) => email && !existingSet.has(email.toLowerCase()));
  if (!recipientsToAdd.length) return current;

  return current
    ? `${current}, ${recipientsToAdd.join(", ")}`
    : recipientsToAdd.join(", ");
}
